module.exports = __webpack_public_path__ + "img/integralPlay_draw_bg.5b944863.png";